module.exports = __webpack_public_path__ + "static/img/lge.d82b02d.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/lge.gif
// module id = kaJQ
// module chunks = 0